import readmore from "../../../common/Readmore";
export default {
  mounted: function() {
    readmore();
  }
};
